/*
 * @Descripttion:盲盒墙退货订单
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2023-05-09 16:35:56
 */
import axios from '../.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const goodreturnorder = {
    // 列表
    list (params) {
        return axios.get(api + 'mangheqianggoodreturnorder/list', { params: params })
    },
    detail (params) {
        return axios.get(api + 'mangheqianggoodreturnorder/detail', { params: params })
    },
    //审核
    review (params) {
        return axios.post(api + 'mangheqianggoodreturnorder/review', qs.stringify(params))
    },
}


// 导出接口
export default goodreturnorder



